import Choices from 'choices.js';
import CC from "cookieconsent";
import htmx from 'htmx.org';

// Search and pagination of the profile lists swap only the list (hx-get)
window.htmx = htmx;

//Password send
const newpasswordfield = document.querySelector('.newpassword');
if(newpasswordfield) {
    document.querySelector('.sendnewpassword').style.display = 'none';

    newpasswordfield.addEventListener('keydown', function() {
        document.querySelector('.sendnewpassword').style.display = '';
    })
}


//Mobile menu toggle
const button = document.querySelector('[data-behaviour="mobile-menu-toggle"]');

if(button) {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.toggle('body--show-mobile-menu');
    });
}

//Selectbox
const linkboxes = document.querySelectorAll('[data-behaviour="selectbox-links"]');

const choices = [...linkboxes].map(node => {
    node.addEventListener('change', (e) => {
       document.location.href = e.target.value;
    });
    return new Choices(node);
});

//Selectbox
const treeLinks = document.querySelectorAll('[data-behaviour="module-tree"] > li > a');

[...treeLinks].map(node => {
    node.addEventListener('click', (e) => {
        e.preventDefault();
        e.currentTarget.parentNode.classList.toggle('module--open');
    });
});

//More functionality
const moreTexts = document.querySelectorAll('[data-behaviour="more-text"]');

[...moreTexts].forEach(text => {
    text.querySelector('.more-button').addEventListener('click', () => {
        text.classList.toggle('section--text--open');
    })
})

//Copy address to clipboard (management certificate area)
const fallbackCopy = (text, cb) => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) { /* noop */ }
    document.body.removeChild(ta);
    if (cb) cb();
};

document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-behaviour="copy-address"]');
    if (!trigger) return;
    e.preventDefault();
    const address = trigger.getAttribute('data-address') || '';
    const label = trigger.querySelector('span');
    const feedback = () => {
        if (!label) return;
        const original = label.textContent;
        label.textContent = 'Kopiert!';
        setTimeout(() => { label.textContent = original; }, 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(address).then(feedback).catch(() => fallbackCopy(address, feedback));
    } else {
        fallbackCopy(address, feedback);
    }
});

document.addEventListener('DOMContentLoaded', function() {
   // Hide global-login when scrolled down
    const globalLogin = document.querySelector('.global-login');
    if(globalLogin) {
        window.addEventListener('scroll', function() {
            if(window.scrollY > 300) {
                globalLogin.classList.add('global-login--hidden');
            } else {
                globalLogin.classList.remove('global-login--hidden');
            }
        });
    }
});


const sendResult = (passing, awarded, passing_percent, awarded_percent, duration) => {

    const lessonView = document.querySelector('[data-behaviour="lesson-view"]');

    document.getElementById('AwardedPercentData').innerHTML = awarded_percent+"%";
    document.getElementById('AwardedData').innerHTML = awarded;
    document.getElementById('PassingPercentData').innerHTML = passing_percent+"%";
    document.getElementById('PassingData').innerHTML = passing;

    if(awarded > passing) {
        lessonView.classList.add('lesson--completed')
    } else {
        lessonView.classList.add('lesson--failed')
    }
    const saveLink = lessonView.getAttribute('data-saveurl');

    var data = new FormData();
    data.append('Passing', passing);
    data.append('Awarded', awarded);
    data.append('PassingPercent', passing_percent);
    data.append('AwardedPercent', awarded_percent);
    data.append('Duration', duration);

    fetch(saveLink, {
        method: 'POST',
        body: data
    })
        .then(response => response.text())
        .then(text => {
        // const lessonNext = document.querySelector('[data-behaviour="lesson-next"]');
        // lessonNext.innerHTML = text;
    });
};

window.sendResult = sendResult;

window.addEventListener("load", function () {
    // Actually starting analytics up
    function addAnalytics() {
        var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
        g.type = "text/javascript";
        g.defer = true;
        g.async = true;
        g.src = "https://www.googletagmanager.com/gtag/js?id=G-ET7NT832W7";
        s.parentNode.insertBefore(g, s);

        window.dataLayer = window.dataLayer || [];

        function gtag() {
            dataLayer.push(arguments);
        }

        gtag('js', new Date());
        gtag('config', 'G-ET7NT832W7');
    }

    function optOut() {
        window['ga-disable-G-ET7NT832W7'] = true;
    }

    const config = JSON.parse(document.getElementById('config').innerHTML);

    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "rgba(255, 255, 255, 0.9)",
                "border-color": "#285C87",
                "text": "#3D3D3D"
            },
            "button": {
                "background": "#AECA54",
                "text": "#ffffff"
            }
        },
        "position": "bottom-right",
        "theme": "edgeless",
        "type": "opt-in",
        "content": {
            "message": config.message,
            "allow": config.allow,
            "deny": config.deny,
            "link": config.link,
            "href": config.href,
            "policy": config.policy
        },
        onInitialise: function (status) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onStatusChange: function (status, chosenBefore) {
            var didConsent = this.hasConsented();
            if (didConsent) {
                addAnalytics();
            } else {
                optOut();
            }
        },
        onRevokeChoice: function () {
            optOut();
        },
    });
});
